import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalLoginComponent } from './login/login.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PortalLoginAreaRoutingModule } from './portal-login-area-routing.module';
import { PortalLoginAreaLayoutComponent } from './layout/login-layout.component';
import { PortalLoginChooseOrganizationComponent } from './choose-organization/choose-organization.component';
import { InfrastructureModule } from '../../../../infra/infrastructure.module';
import { PortalLoginChangePasswordComponent } from './change-password/change-password.component';
import { CaptchaComponent } from './_partials/captcha/captcha.component';

@NgModule({
    declarations: [
        PortalLoginAreaLayoutComponent,
        PortalLoginComponent,
        PortalLoginChooseOrganizationComponent,
        PortalLoginChangePasswordComponent,
        CaptchaComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        RouterModule,
        InfrastructureModule,
        PortalLoginAreaRoutingModule
    ],
    providers: [
    ]
})
export class PortalLoginAreaModule {
}
